import { useQuery } from '@tanstack/react-query';

import { disbursementService } from '../services/disbursement.service';

export const usePendingDisbursements = () => {
  return useQuery({
    queryKey: ['disbursement'],
    queryFn: () => disbursementService.listPendingDisbursement()
  });
};
